import classNames from "classnames";
import locale from "localization";
import React from "react";
import { TIER_ROWS } from "./account-type-vip-tiers.utils";
import styles from "./account-type-vip-tiers-table.module.scss";

const AccountTypeVipTiersTable = ({
  groupLabel,
  columns,
  renderHeader,
  renderField,
  headerAction,
}) => {
  const columnCount = columns.length + (headerAction ? 1 : 0);

  const pair = (first, second) => (
    <div className={styles.pair}>
      <div>{first}</div>
      <div>{second}</div>
    </div>
  );

  const renderRow = (row, index) => {
    if (row.spacer) {
      return (
        <tr key={index} className={styles.spacerRow}>
          <td className={styles.sticky} />
          <td colSpan={columnCount} />
        </tr>
      );
    }
    if (row.section) {
      return (
        <React.Fragment key={index}>
          <tr className={styles.sectionRow}>
            <td className={styles.sticky}>{row.section}</td>
            <td colSpan={columnCount} />
          </tr>
          {row.pairHeader && (
            <tr>
              <td className={styles.sticky} />
              {columns.map((column) => (
                <td key={column.key} className={styles.subHeader}>
                  {pair(locale.points, row.pairHeader)}
                </td>
              ))}
            </tr>
          )}
        </React.Fragment>
      );
    }
    const [first, second] = row.fields;
    return (
      <tr key={index}>
        <td className={classNames(styles.sticky, row.strong ? styles.strongLabel : styles.label)}>
          {row.label}
        </td>
        {columns.map((column) => (
          <td key={column.key} className={styles.value}>
            {second
              ? pair(renderField(column, ...first), renderField(column, ...second))
              : renderField(column, ...first)}
          </td>
        ))}
      </tr>
    );
  };

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <colgroup>
          <col className={styles.labelColumn} />
          {columns.map((column) => (
            <col key={column.key} className={styles.tierColumn} />
          ))}
          {headerAction && <col />}
        </colgroup>
        <thead>
          <tr className={styles.accountTypeNameRow}>
            <th className={classNames(styles.sticky, styles.label)}>{locale.accountTypeName}</th>
            <td className={classNames(styles.stickyValue, styles.value)}>{groupLabel}</td>
            {columnCount > 1 && <td colSpan={columnCount - 1} />}
          </tr>
          <tr>
            <th className={styles.sticky} />
            {columns.map((column) => (
              <th key={column.key} className={styles.tierHeader}>
                {renderHeader(column)}
              </th>
            ))}
            {headerAction && <th className={styles.headerAction}>{headerAction}</th>}
          </tr>
        </thead>
        <tbody>{TIER_ROWS.map(renderRow)}</tbody>
      </table>
    </div>
  );
};

export default AccountTypeVipTiersTable;
